/**
 * Creates a container element for action buttons in the top bar.
 * All action buttons will be appended to this container.
 */

import i18n from '@i18n';

export const initActionsContainer = (lightbox) => {
  lightbox.on('uiRegister', () => {
    lightbox.pswp.ui.registerElement({
      name: 'actions-container',
      ariaLabel: i18n.TOOLBAR.ACTIONS,
      className: 'mwl__actions',
      order: 100, // High order to ensure it's after counter
      isButton: false,
      html: '',
      appendTo: 'bar',
    });
  });

  // Move buttons into container after opening animation ends (all UI elements are ready)
  lightbox.on('openingAnimationEnd', () => {
    moveButtonsToContainer(lightbox);
  });

  // Also try on firstUpdate as fallback with small delay
  lightbox.on('firstUpdate', () => {
    setTimeout(() => {
      moveButtonsToContainer(lightbox);
    }, 50);
  });
};

function moveButtonsToContainer(lightbox) {
  const topBar = lightbox.pswp.topBar;
  if (!topBar) return;

  const container = topBar.querySelector('.mwl__actions');
  if (!container || container.children.length > 0) return; // Already populated

  // Get all buttons that should be in the actions container (in order)
  const buttonSelectors = [
    '.pswp__button--slideshow-button',
    '.pswp__button--metadata-toggle-button',
    '.pswp__button--map-button',
    '.pswp__button--download-button',
    '.pswp__button--social-share-button',
    '.pswp__button--fullscreen-button',
    '.pswp__button--custom-close',
  ];

  buttonSelectors.forEach(selector => {
    const button = topBar.querySelector(selector);
    if (button) {
      container.appendChild(button);
    }
  });
}
